<script setup>
import { ref, onMounted, computed } from "vue";
import LocalStorage from '@/controller/LocalStorage.js';
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import MazSelect from 'maz-ui/components/MazSelect';
const i18n = useI18n();
const { t } = useI18n();
const router = useRouter();
const localeArray = {
  ca: 'Català',
  es: 'Español',
  gb: 'British english',
  us: 'American english',
  fr: 'Français',
  pt: 'Português',
  it: 'Italiano',
};
const localeArraySimple = {
  ca: 'CA',
  es: 'ES',
  gb: 'GB',
  us: 'US',
  fr: 'FR',
  pt: 'PT',
  it: 'IT',
};
const langOptions = [
  {value: 'ca',label: 'Català'},
  {value: 'es',label: 'Español'},
  {value: 'gb',label: 'British english'},
  {value: 'us',label: 'American english'},
  {value: 'fr',label: 'Français'},
  {value: 'pt',label: 'Português'},
  {value: 'it',label: 'Italiano'}
]
const props = defineProps({
  lang: String,
  mode: Number,
});
const locale = ref(i18n.locale)

const emit = defineEmits(['changeInput', 'save']);

function switchLocale(loc) {
  router.replace({ params: { lang: locale.value } });
  emit('changeInput', locale.value, 'lang');
  emit('save');
}

if(locale.value == '' || !(i18n.availableLocales).includes(locale.value) || props.lang == '' || !(i18n.availableLocales).includes(props.lang)) {
  locale.value = 'es'
}
onMounted(() => {
});
const isLoginView = computed(() => router.currentRoute.value.path === '/login')
</script>

<template>
  <div class="local-switcher">
    <MazSelect
        v-model="locale"
        :label="t('field.language')"
        color="primary"
        listPosition="top left"
        class="language-selector"
        :options="langOptions"
        rounded-size="full"
        size="sm"
        @update:model-value="switchLocale"
        :class="{'custom-login-select': isLoginView}"
    />
  </div>
</template>

<style lang="scss">
select {
  border: 1px solid #e2e8f0;
  border-radius: 0.24rem;
  padding: 2px 10px;
  height: 38px;
  width: 100%;
  background-color: white !important;
  option{
    color: black;
    font-size: 17px;
  }
  .locale-switcher-option span {
    color: black;
    font-size: 17px;
  }
}
select:focus {
  outline: none;
}
.language-selector{
  width: 100%;
  .m-select-list{
    width: 100%;
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}
@media (max-width:1024px) and (orientation: portrait){
    .custom-login-select, .m-select.--is-open.language-selector.custom-login-select.--sm {
      .m-input-wrapper{
          .m-input-wrapper-input {
            color: #808594;
            input{
              color: #808594;
              font-size: 10px;
            }
        }
          span.m-input-label {
            font-size: 9px !important;
        }
        .m-input-wrapper-right {
            svg.m-select-chevron.maz-text-xl {
              color: #808594;
          }
        }
        
      }
    }
  }

  @media (min-width: 577px) and (max-width: 1024px) and (orientation: portrait) {
    .custom-login-select, .m-select.--is-open.language-selector.custom-login-select.--sm {
      .m-input-wrapper{
        span.m-input-label {
            font-size: 18px !important;
        }
      }
    }
  }

</style>
